import StockDisplay from './StockDisplay';

export default StockDisplay;
